import { render, staticRenderFns } from "./AlertCompletarCadastro.vue?vue&type=template&id=4595ae9c&"
import script from "./AlertCompletarCadastro.vue?vue&type=script&lang=js&"
export * from "./AlertCompletarCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports